import { render, staticRenderFns } from "./AdminPanelMegogoService.vue?vue&type=template&id=7a9736f4&"
import script from "./AdminPanelMegogoService.vue?vue&type=script&lang=js&"
export * from "./AdminPanelMegogoService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports